module.exports = __webpack_public_path__ + "static/media/pause.c6c0b71e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pause.svg
// module id = 712
// module chunks = 0